import * as rpc from 'pm-rpc';
import { window } from '@wix/photography-client-lib';
import {
  proGalleryItemToWixCode,
  wixCodeItemsToProGallery,
  proGalleryItemsToWixCode,
} from '@wix/pro-gallery-items-formatter';

// // wixFullstoryLoader({label: 'progallery-wix-code-api'});

class GalleryWixCodeApi {
  constructor() {
    this.resetGalleryInEditor = this.resetGalleryInEditor.bind(this);

    this.compId = 'pro-gallery-no-comp-id';

    this.waitForWixSdk();
    this.resetGallery();
  }

  waitForWixSdk() {
    this.wixSdkReadyInterval = setInterval(() => {
      if (window.Wix && window.Wix.Utils) {
        clearInterval(this.wixSdkReadyInterval);
        // console.log('proGallery Wix SDK is Ready!');
        this.onWixSdkReady();
      }
    }, 100);
  }

  setClickCallback(callback) {
    if (typeof callback === 'function') {
      this.itemClickedCallbacks.push(callback);
    }
  }

  onItemClicked(itemProps) {
    const _item = {
      compId: this.compId,
      event: {
        action: 'itemClicked',
        id: itemProps.id,
        imageIndex: itemProps.idx,
        item: proGalleryItemToWixCode(itemProps),
      },
    };

    // notify pubsub listeners
    try {
      this.wixSdkReady &&
        window.Wix.PubSub.publish(
          'galleryAction_' + this.compId,
          {
            action: 'onItemClicked',
            payload: _item,
          },
          true,
        );
    } catch (e) {
      console.warn('Gallery failed to publish onItemClicked action', e);
    }

    // activate open callbacks
    try {
      for (let i = 0; i < this.itemClickedCallbacks.length; i++) {
        const callback = this.itemClickedCallbacks[i];
        if (typeof callback === 'function') {
          callback(_item);
        }
      }
    } catch (e) {
      console.warn('Gallery failed to activate onItemClicked callbacks', e);
    }
  }

  setItemChangedCallback(callback) {
    if (typeof callback === 'function') {
      this.itemChangedCallbacks.push(callback);
    }
  }

  onItemChanged(item) {
    try {
      const _item = {
        compId: this.compId,
        event: {
          action: 'imageChanged',
          id: item.id,
          imageIndex: item.idx,
          item: proGalleryItemToWixCode(item),
        },
      };
      this.wixSdkReady &&
        window.Wix.PubSub.publish(
          'galleryAction_' + this.compId,
          {
            action: 'onCurrentItemChanged',
            payload: _item,
          },
          true,
        );
      for (let i = 0; i < this.itemChangedCallbacks.length; i++) {
        const callback = this.itemChangedCallbacks[i];
        if (typeof callback === 'function') {
          callback(_item);
        }
      }
    } catch (e) {
      //
    }
  }
  resetGalleryInEditor() {
    if (
      this.wixSdkReady &&
      window.Wix &&
      window.Wix.Utils &&
      window.Wix.Utils.getViewMode() == 'editor'
    ) {
      this.resetGallery();
    }
  }

  resetGallery() {
    if (
      this.originalGalleryItems &&
      window.proGalleryServices &&
      window.proGalleryServices.setImages
    ) {
      window.proGalleryServices.setImages(this.originalGalleryItems);
    }

    this.itemClickedCallbacks = [];
    this.itemChangedCallbacks = [];
  }

  setItems(items) {
    if (items.length === 1 && items[0].type === 'styleParams') {
      try {
        this.setStyleParams(JSON.parse(items[0].src || items[0].uri));
        return;
      } catch (e) {
        //
      }
    }
    if (window.proGalleryServices) {
      if (!this.originalGalleryItems) {
        this.originalGalleryItems = window.proGalleryServices.getItemsDto();
      }
      window.proGalleryServices.setImages(wixCodeItemsToProGallery(items));
      // console.log('proGallery setItems for WixCode (replaced rendered gallery items)');
    } else {
      if (
        !this.originalGalleryItems &&
        window.prerenderedGallery &&
        window.prerenderedGallery.items
      ) {
        this.originalGalleryItems = window.prerenderedGallery.items;
      }
      // store the items until the proGalleryServices will be ready
      window.itemsFromWixCode = wixCodeItemsToProGallery(items);
      // console.log('proGallery setItems for WixCode (stored items for later render)');
    }
  }

  getItems() {
    if (window.proGalleryServices) {
      return proGalleryItemsToWixCode(window.proGalleryServices.getItemsDto());
    } else {
      return [];
    }
  }

  setStyleParams(styleParams) {
    const mapStyleParams = (styleParams) => {
      const mappedStyleParams = {};
      const keys = Object.keys(styleParams);
      for (const key of keys) {
        mappedStyleParams[key] = mapStyleParam(key, styleParams[key]);
      }
      return mappedStyleParams;
    };

    const mapStyleParam = (key, val) => {
      let newVal = val;
      switch (key) {
        case 'itemClick': {
          switch (val) {
            case 'none':
            case 'disabled':
              newVal = 'nothing';
              break;
            case 'expand':
            case 'fullscreen':
            case 'zoomMode':
              newVal = 'expand';
              break;
            case 'link':
            case 'goToLink':
              newVal = 'link';
              break;
          }
        }
      }
      return newVal;
    };

    try {
      const mappedStyleParams = mapStyleParams(styleParams);
      if (window.proGalleryServices) {
        window.proGalleryServices.overrideStyleParams(mappedStyleParams);
      } else {
        window.styles = mappedStyleParams;
      }
      return mappedStyleParams;
    } catch (e) {
      console.error('Failed to set styleParams', e);
      return false;
    }
  }

  onWixSdkReady() {
    // listen to editor/preview changes
    try {
      window.Wix.addEventListener(
        window.Wix.Events.EDIT_MODE_CHANGE,
        this.resetGalleryInEditor,
      );
      this.compId = window.Wix.Utils.getCompId();
      this.wixSdkReady = true;
    } catch (e) {
      this.wixSdkReady = false;
      // console.warn('Cannot use wix sdk for wixCode', e);
    }

    try {
      this.wixSdkReady &&
        window.Wix.PubSub.subscribe(
          'galleryAction_' + this.compId,
          ({ data }) => {
            const api = this.generatePubsubApi();
            if (typeof api[data.action] === 'function') {
              api[data.action](data.payload);
            }
          },
          true,
        );
    } catch (e) {
      console.warn('Cannot subscribe to wix pubsub for wixCode', e);
    }
  }

  generateApi() {
    return {
      getItems: () => this.getItems(),
      setItems: (items) => this.setItems(items),
      onItemClicked: (callback) => this.setClickCallback(callback),
      onCurrentItemChanged: (callback) => this.setItemChangedCallback(callback),
      setClickAction: (action) => this.setStyleParams({ itemClick: action }), // action is: 'none' / 'expand' / 'link'
      setStyleParams: (styleParams) => this.setStyleParams(styleParams),
    };
  }

  generatePubsubApi() {
    return {
      getItems: () => this.getItems(),
      setItems: ({ items }) => this.setItems(items),
      onItemClicked: ({ callback }) => this.setClickCallback(callback),
      onCurrentItemChanged: ({ callback }) =>
        this.setItemChangedCallback(callback),
      setClickAction: ({ action }) =>
        this.setStyleParams({ itemClick: action }), // action is: 'none' / 'expand' / 'link'
      setStyleParams: ({ styleParams }) => this.setStyleParams(styleParams),
    };
  }
}

const galleryWixCodeApi = (window.galleryWixCodeApi = new GalleryWixCodeApi());

try {
  rpc.api.set('publicApi', galleryWixCodeApi.generateApi());
  // console.log('proGallery WixCode exportAPI complete');
} catch (e) {
  // console.warn('Error in WixCode exportAPI ', e);
}

// try {
//   Wix.Performance.applicationLoaded(); //report application ready to wixCode
// } catch (e) {
//   console.warn('Error reporting applicationLoaded to wixCode', e);
// }
